import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { PrimaryButton } from '../ui/PrimaryButton';
import { SectionTag } from '../ui/SectionTag';
import { scrollToId } from '../../utils/scroll';
const points = [{
  n: '01',
  emoji: '😩',
  tag: 'El "apañao"',
  title: 'Eres el "apañao" de la casa.',
  text: 'Tienes herramientas en el trastero, en el garaje o en el sótano. Te gustaría que por fin generaran ingresos extra los fines de semana.'
}, {
  n: '02',
  emoji: '📉',
  tag: 'Retales',
  title: 'Tienes el taller lleno de retales.',
  text: 'Te duele tirar maderas nobles (roble, haya, pino) porque sabes que valen dinero. Ves un tablero de 80€ y piensas: "¿Qué podría hacer con esto?"'
}, {
  n: '03',
  emoji: '👥',
  tag: 'Reformas pesadas',
  title: 'Estás harto de reformas pesadas.',
  text: 'Cansado de presupuestar trabajos grandes que nunca se confirman. De clientes que regatean cada euro. De trabajar 8 horas por 150€.'
}, {
  n: '04',
  emoji: '💰',
  tag: 'Dinero rápido',
  title: 'Quieres dinero rápido.',
  text: 'No necesitas ser millonario. Solo necesitas +500€/mes extra para pagar el alquiler del taller o tus gastos fijos.'
}, {
  n: '05',
  emoji: '💼',
  tag: 'Negocio real',
  title: 'Buscas un negocio real.',
  text: 'Quieres que te reconozcan como un artesano profesional con una marca propia. Tener un catálogo. Vender en línea sin vergüenza.'
}, {
  n: '06',
  emoji: '🎁',
  tag: 'Mercado Montessori',
  title: 'Te intriga el mercado Montessori.',
  text: 'Ves cómo otros venden torres de aprendizaje a 150€ y piensas: "Yo podría hacerlo."'
}];
export function ForYou() {
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-75" data-mp="ls25qipnatel">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-76" data-mp="gth1m879vpkv">
        <SectionTag icon="👀" data-id="element-77" data-mp="vr12b2x4yyl8">Esto es para ti si…</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-ink sm:text-4xl" data-id="element-78" data-mp="vrj9gulc6x7x">
          ¿Te suena alguna de estas escenas?
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-79" data-mp="xvwbnj5tr8cf">
          Si te identificas con 2 o más, el KIT DEL TALLER RENTABLE fue diseñado para ti.
        </p>
      </div>

      <div className="mx-auto mt-8 grid max-w-6xl gap-4 px-4 sm:grid-cols-2 sm:px-6 lg:grid-cols-3" data-id="element-80" data-mp="17sskjpzmxwhi">
        {points.map((point, i) => <m.div key={point.n} initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i % 3 * 0.08
      }} className="relative flex flex-col rounded-2xl border border-brown/20 bg-white p-6 shadow-card" data-id="element-81" data-mp="1cksqq06atlmj" data-mpi={i}>
            <div className="flex items-center justify-between" data-id="element-82" data-mp="1vivde8bdj6h6">
              <span className="font-heading text-3xl font-bold text-brown/10" data-id="element-83" data-mp="1vi3p7ik3wb0x">{point.n}</span>
              <span className="text-2xl" aria-hidden="true" data-id="element-84" data-mp="3scztwf1loe3j">
                {point.emoji}
              </span>
            </div>
            <span className="mt-3 inline-block w-fit rounded-full bg-brown/10 px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-brown" data-id="element-85" data-mp="3pqqqkwpy1i5l">
              {point.tag}
            </span>
            <h3 className="mt-3 font-heading text-base font-bold leading-snug text-ink" data-id="element-86" data-mp="3g0xezvpsx31c">{point.title}</h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-muted" data-id="element-87" data-mp="3b1ui4yjz634g">{point.text}</p>
            <div className="mt-4 flex h-6 w-6 items-center justify-center rounded-full bg-success/15" data-id="element-88" data-mp="3b001hwfqkx66">
              <CheckIcon size={14} className="text-success" data-id="element-89" data-mp="7l49ebx0dbz2" />
            </div>
          </m.div>)}
      </div>

      <div className="mx-auto mt-8 max-w-2xl px-4 text-center sm:px-6" data-id="element-90" data-mp="2lrceycfaoir">
        <div className="mt-6 flex justify-center" data-id="element-91" data-mp="2o43c105s97y">
          <PrimaryButton onClick={() => scrollToId('oferta-base')} data-id="element-92" data-mp="3tramxy2p0hqo">Quiero el Kit del Taller Rentable</PrimaryButton>
        </div>
      </div>
    </section>;
}